const alarmDefs = {
    "0": "PV volt high",
    "1": "Bat volt high",
    "2": "Isolation low",
    "3": "Leakage current high",
    "4": "Over temperature",
    "5": "DC Bus unbalance",
    "6": "DC Bus high",
    "7": "DC Bus low",
    "8": "Grid Eps port reverse",
    "9": "Relay open failure",
    "10": "Relay stick failure",
    "11": "Bus soft start failure",
    "12": "MCU Internal comm failure",
    "13": "Parallel comm line loss",
    "17": "Bat SOC low on Grid",
    "18": "Bat SOC low in EPS",
    "19": "Bat volt low",
    "20": "Bat open",
    "21": "Bat SOC extremely low",
    "22": "BMS comm failure",
    "23": "TOU mode no time setting",
    "24": "Remote off",
    "25": "Meter comm failure",
    "32": "Utility volt high",
    "33": "Utility volt low",
    "34": "Utility frequency high",
    "35": "Utility frequency low",
    "36": "Utility loss",
    "37": "Grid wave loss",
    "38": "DC inject high",
    "39": "Utility not three phase",
    "41": "PLL failure",
    "48": "Eps over load",
    "49": "Eps volt low",
    "50": "Eps volt high",
    "51": "Eps Bus soft start failure",
    "52": "Eps Inv soft start failure",
    "53": "Eps output short",
    "64": "Bat trip",
    "65": "Output open circuit",
    "66": "Inv trip",
    "67": "Bus trip"
}


function parseAlarmData(ErrorCode1, ErrorCode2,ErrorCode3) {
    const InverterAlarms = [];
    const BatteryAlarms = []
    ErrorCode1 = ((ErrorCode1 & 0xFFFF) << 16) | ((ErrorCode1 >> 16) & 0xFFFF);
    ErrorCode2 = ((ErrorCode2 & 0xFFFF) << 16) | ((ErrorCode2 >> 16) & 0xFFFF);
    ErrorCode3 = ((ErrorCode3 & 0xFFFF) << 16) | ((ErrorCode3 >> 16) & 0xFFFF);
    const cs = [ErrorCode1,ErrorCode2, ErrorCode3];
    for (let i = 0; i < cs.length; i++) {
        const c = cs[i];
        if (c == 0) {
            continue;
        }

        for (let j = 0; j < 32; j++) {
            const bit = (c >> j) & 1;
            if (bit === 1) {
                const alarmCode = i * 32 + j;
                InverterAlarms.push({"Code": alarmCode, "Name": alarmDefs[alarmCode]});
                if (alarmCode == 1 || (alarmCode >= 17 && alarmCode <= 21) || alarmCode == 64) {
                    BatteryAlarms.push({"Code": alarmCode, "Name": alarmDefs[alarmCode]});
                }
            }
        }
    }

    return {InverterAlarms, BatteryAlarms};
}

export default {
    parseAlarmData,
}